import { Button } from "~/components/button";
import { copyToClipboard } from "~/utils/helpers";
import { toast } from "~/utils/toast";

export const ManuscriptProcessingCopyButton = ({
  value,
  label,
  copiedMessage,
}: {
  value: string;
  label: string;
  copiedMessage: string;
}) => {
  const onClick = async () => {
    await copyToClipboard({ arrayToCopy: [value] });
    toast.success(copiedMessage);
  };

  return (
    <Button
      variant="ghost"
      icon="copy"
      size="small"
      aria-label={label}
      onClick={onClick}
      // The pseudo-element lifts a 20px glyph to a 32px target in place.
      className="relative h-5 w-5 shrink-0 p-0 duration-100 ease-out after:absolute after:-inset-1.5 after:content-[''] focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-hidden active:scale-[0.96] motion-reduce:transition-none motion-reduce:active:scale-100"
      iconClassName="w-3! h-3!"
    />
  );
};
